/*
 *   File : list.js
 *   Author : https://evoqins.com
 *   Description : Manage catalog page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryButton, TextButton } from '../../../Component/Buttons';
import { CustomSelectBox } from '../../../Component/FormElements';
import { Pagination } from '../../../Component/pagination';
import { APIService } from '../../../Service';
import { EmptyScreen } from '../../../Component/EmptyComponent';
import { Loader } from '../../../Component/Others';

const CATEGORY_TAB = [
    {
        id: 2,
        name: "Indoor"
    },
    {
        id: 1,
        name: "Exterior"
    }
];

const CATEGORY = [
    {
        value: null,
        label: 'All',
    },
    {
        value: 1,
        label: 'sample'
    },
    {
        value: 2,
        label: 'Sample 2'
    },
];

const ITEMS_PER_PAGE = 16;

const Catalog = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [tabIndex, setTabIndex] = useState(0);
    const [toggleFilter, setToggleFilter] = useState(false);

    const [productType, setProductType] = useState(null);
    const [selectedSurface, setSelectedSurface] = useState(null);
    const [selectedFinish, setSelectedFinish] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState(null);

    const [totalPageCount, setTotalPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const [clearFilter, setClearFilter] = useState(false);
    const [filterData, setFilterData] = useState({});

    const [listData, setListData] = useState({});
    const [loader, setLoader] = useState(true);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth' //scroll top
        });

        _getFilterData();
    }, []);

    useEffect(() => {
        if (tabIndex !== 0) {
            _getListData();
        }
    }, [tabIndex, currentPage]);

    useEffect(() => {
        if (clearFilter === true) {
            _getListData();
        }
    }, [clearFilter]);

    useEffect(() => {
        if (state !== null) {
            if (state?.tab_index) {
                setTabIndex(state.tab_index);
            } else {
                setTabIndex(2);
            }
        } else {
            setTabIndex(2);
        }
    }, [state]);

    // handle tab change 
    const _handleTabChange = (id) => {
        navigate("/catalog", {
            state: {
                tab_index: id
            }
        });
    };

    // handle toggle filter 
    const _handleToggleFilter = () => {
        setToggleFilter(prev => !prev);
    };

    //handle pagination
    const _handlePagination = (new_start_limit) => {
        const selected_page = Math.floor(new_start_limit / ITEMS_PER_PAGE) + 1;
        setCurrentPage(selected_page);
    };

    // handle details
    const _handleDetail = (id) => {
        navigate("detail", {
            state: {
                tab_index: tabIndex,
                catalogue_id: id
            }
        })
    };

    const _handleClearAll = () => {

        setProductType(filterData.product_type[0] ?? null);
        setSelectedSurface(filterData.surface[0] ?? null);
        setSelectedFinish(filterData.finish[0] ?? null);
        setSelectedBrand(filterData.brand[0] ?? null);


        setClearFilter(true);
        setCurrentPage(1);
    };


    // API - Get Filter data
    const _getFilterData = () => {
        let is_post = false;
        let url = 'CA/catalogue/filter-data';
        let data = {};

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setFilterData(response.data);

                setProductType(response.data.product_type[0] ?? null);
                setSelectedSurface(response.data.surface[0] ?? null);
                setSelectedFinish(response.data.finish[0] ?? null);
                setSelectedBrand(response.data.brand[0] ?? null);
            } else { }
        });
    };

    // API - Get Filter data
    const _getListData = (page_num = currentPage) => {
        setLoader(true);

        let is_post = true;
        let url = 'CA/catalogue/list';
        let data = {
            "category": tabIndex,
            "product_type": productType?.value || null,
            "surface": selectedSurface?.value || null,
            "finish": selectedFinish?.value || null,
            "brand": selectedBrand?.value || null,
            "search_query": null,
            "page_num": page_num,
            "limit": ITEMS_PER_PAGE
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setListData(response);

                setTotalPageCount(Math.ceil(response.total_count / ITEMS_PER_PAGE));
            } else {
                setListData({});
            }
            setLoader(false);
            setClearFilter(false);
        });
    };

    return (
        <section className='pb-5 '>
            <div className={`e-bg-lavender-blush-light padding-12px-top padding-52px-lr`}>
                <h1 className='mb-0 e-primary-font-playfair e-font-24 line-height-32px e-text-raisin-black e-font-weight-600'>
                    Manage Catalogue
                </h1>

                {/* category tab */}
                <div className='d-flex flex-wrap padding-40px-top padding-20px-bottom justify-content-space-between align-items-center'>
                    <div className='d-flex gap-0-16 overflow-auto pb-xl-0 pb-lg-0 pb-md-0 pb-1 e-tab-scroll'>
                        {CATEGORY_TAB.map((data, key) => (
                            <div key={key} className={`${tabIndex === data.id ? 'e-bg-lust e-text-white border-transparent pe-none' : 'e-text-rich-black e-border-1px-cool-grey'} transition e-border-radius-24 cursor-pointer`}
                                onClick={() => _handleTabChange(data.id)} >
                                <p className='mb-0 w-max-content px-4 padding-12px-tb e-alt-font-noto-sans e-font-14 e-font-weight-500 line-height-14px'>
                                    {data.name}
                                </p>
                            </div>
                        ))}
                    </div>

                    <div className='d-flex align-items-center gap-3'>
                        <PrimaryButton name="Add new product"
                            className="e-border-radius-16 padding-14px-tb line-height-12px e-font-16"
                            onPress={() => {
                                navigate("manage-product", {
                                    state: {
                                        tab_index: tabIndex,
                                    }
                                })
                            }} />
                        <img src={toggleFilter ? require("../../../Assets/Image/filter-icon-white.svg").default :
                            require("../../../Assets/Image/filter-icon.svg").default}
                            draggable={false}
                            className={`${toggleFilter ? `e-bg-indigo` : ``} transition e-border-1px-cool-grey e-border-radius-8 p-2 cursor-pointer`}
                            alt='filter'
                            onClick={_handleToggleFilter} />
                    </div>
                </div>
            </div>


            <div className='padding-52px-lr'>
                {/* filter */}
                {toggleFilter &&
                    <div className='e-bg-anti-flash-white-dark py-3 px-4 my-3'>
                        <div className='row row-cols-4 g-3'>
                            <div className='col'>
                                <CustomSelectBox label="Product type"
                                    value={productType}
                                    options={filterData.product_type ?? []}
                                    type={2}
                                    optional={true}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    labelClass="e-font-weight-600"
                                    isSearchable={false}
                                    selectChange={(value) => setProductType(value)}
                                />
                            </div>

                            <div className='col'>
                                <CustomSelectBox label="Surface"
                                    value={selectedSurface}
                                    options={filterData.surface ?? []}
                                    type={2}
                                    optional={true}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    labelClass="e-font-weight-600"
                                    isSearchable={false}
                                    selectChange={(value) => setSelectedSurface(value)}
                                />
                            </div>

                            <div className='col'>
                                <CustomSelectBox label="Finish"
                                    value={selectedFinish}
                                    options={filterData.finish ?? []}
                                    type={2}
                                    optional={true}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    labelClass="e-font-weight-600"
                                    isSearchable={false}
                                    selectChange={(value) => setSelectedFinish(value)}
                                />
                            </div>

                            <div className='col'>
                                <CustomSelectBox label="Brand"
                                    value={selectedBrand}
                                    options={filterData.brand ?? []}
                                    type={2}
                                    optional={true}
                                    className="e-bg-white e-border-radius-4 e-table-select"
                                    minHeight="34px"
                                    padding="0 8px"
                                    wrapperHeight="0px"
                                    labelClass="e-font-weight-600"
                                    isSearchable={false}
                                    selectChange={(value) => setSelectedBrand(value)}
                                />
                            </div>
                        </div>

                        <div className='d-flex gap-3 align-items-center justify-content-end pt-3'>
                            <TextButton name="Clear all"
                                onPress={_handleClearAll} />
                            <PrimaryButton name="Filter now"
                                className="px-3 py-1 e-border-radius-8"
                                onPress={() => {
                                    _getListData(1);
                                }} />
                        </div>
                    </div>
                }

                {loader ?
                    <Loader />
                    :
                    <div className={`${toggleFilter ? "" : " pt-4"} row mt-2 row-gap-3`}>
                        {Object.keys(listData).length !== 0 && listData?.data?.length !== 0 ?
                            <>
                                {listData.data.map((data, index) => (
                                    <div key={index} className='col-6'>
                                        <div className='e-admin-box-shadow e-border-radius-16 py-3 ps-3 pe-4 e-bg-white cursor-pointer'
                                            onClick={() => _handleDetail(data.id)}>
                                            <div className='d-flex gap-0-16'>
                                                <div className='position-relative'>
                                                    <div className='e-bg-bright-gray-dark e-border-radius-8 ' style={{ height: "136px", width: "130px" }}>
                                                        <img src={data.product_image}
                                                            draggable={false}
                                                            className='e-border-radius-8 object-fit-contain'
                                                            height={136}
                                                            width={130}
                                                            alt='product' />
                                                    </div>
                                                    {data.highlight_tag &&
                                                        <span className='top-0 start-0 position-absolute e-bg-spanish-yellow px-3 py-1 e-border-radius-16 left-0 e-alt-font-noto-sans e-text-white e-font-12 e-font-weight-400 line-height-16px'>
                                                            {data.highlight_tag}
                                                        </span>
                                                    }
                                                </div>
                                                <div className='d-flex flex-column justify-content-between'>
                                                    <div>
                                                        <p className='mb-2 e-alt-font-noto-sans e-text-davys-grey e-font-14 e-font-weight-400 line-height-22px e-ellipse'>
                                                            {data.product_type}
                                                        </p>
                                                        <h6 className='mb-2 e-primary-font-playfair e-text-charleston-green e-font-16 e-font-weight-600 line-height-22px e-ellipse-3-line '>
                                                            {data.name}
                                                        </h6>

                                                    </div>
                                                </div>
                                            </div>
                                            {/* Button view detail page */}
                                            <div className='text-end margin-top-neg-22px'>
                                                <TextButton name="View details" />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </>
                            :
                            <div className='h-100vh py-5 my-5'>
                                <EmptyScreen message="No data found" />
                            </div>
                        }
                    </div>
                }

                {/* pagination */}
                {totalPageCount > 1 &&
                    <div className="d-flex justify-content-center e-gap-0-16 mt-4 pt-3">
                        <Pagination itemsPerPage={ITEMS_PER_PAGE}
                            totalPage={totalPageCount}
                            showFirstLastPages={true}
                            onChange={_handlePagination} />
                    </div>
                }
            </div>
        </section>
    )
}

export default Catalog;
